import React, { memo } from 'react';
import { TextInput } from '@adc/parallax-component-library';
import InputErrorField from 'Components/utility/InputErrorField';
const Input = memo(({ isInvalid = false, label = '', errorMessage, placeholder = '', onBlur, onChangeText, disabled, testID, inputMode, onFocus, ...rest }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(TextInput, { inputMode: inputMode, label: label, placeholder: placeholder, onFocus: onFocus, onBlur: onBlur, error: isInvalid, onChangeText: onChangeText, testID: testID, disabled: disabled, ...rest }),
        isInvalid && errorMessage && (React.createElement(InputErrorField, { errorMessage: errorMessage, testID: testID }))));
});
Input.displayName = 'Input';
export { Input };
